module.exports = __webpack_public_path__ + "img/nanjing.5e63477.png";